import { useEffect, useState } from 'react';
import './App.css';
import FloatingLines from './components/FloatingLines';
import SplitText from './components/SplitText';

const profile = {
  name: '조상원',
  nameEn: 'Cho Sangwon',
  role: '',
  birth: '2002.04.10',
  tagline: '문제를 정의하고, 끝까지 완성하는 개발자',
  intro:
    '끊임없이 학습하고 아이디어를 실현하는 개발자입니다. 단순 구현을 넘어 문제를 정의하고, 팀과 함께 제품을 완성하고 유지보수하는 과정을 중요하게 생각합니다.',
  phone: '010-6255-5579',
  email: 'chosw0410@naver.com',
  github: 'https://github.com/sangwon5579',
  blog: 'https://velog.io/@sangwon5579/posts',
  photo: '/image/sangwon.png',
};

const focusKeywords = ['문제 정의', '풀스택 구현', '배포 · 운영', 'AI · 데이터'];

const skillGroups = [
  { title: 'Language', items: ['Java', 'Python', 'SQL', 'C++'] },
  { title: 'Backend', items: ['Spring Boot', 'Django', 'JPA', 'FastAPI'] },
  { title: 'Frontend', items: ['Vue.js'] },
  { title: 'DevOps / Infra', items: ['Docker', 'AWS EC2', 'Render', 'Supabase', 'AWS Lambda'] },
  { title: 'Collaboration', items: ['GitHub', 'Notion', 'API Dog'] },
];

const education = {
  school: '중앙대학교 소프트웨어학부',
  period: '2021 - 재학 중',
  degree: '소프트웨어 전공',
  capstone: {
    title: '캡스톤디자인 — VERITAS',
    desc: '로컬 기반 AI 리서치·문서작성 어시스턴트 (2026.03 - 2026.06)',
  },
};

const activities = [
  { period: '2024.03 - 2024.12', title: '소프트웨어학부 알고리즘 동아리 ChAOS' },
  { period: '2025.06 - 2025.12', title: '한화시스템 BEYOND SW CAMP 풀스택 과정' },
  { period: '2026.03 - 현재', title: '멋쟁이사자처럼 중앙대학교 백엔드' },
  { period: '2026.06 - 현재', title: 'CSLab 학부연구생', url: 'https://www.cslab.cau.ac.kr/' },
];

const certifications = [
  { name: 'SQL 개발자 (SQLD)', date: '2025.04' },
  { name: 'TOPCIT LEVEL 3', date: '2025.05' },
  { name: '데이터 분석 준전문가 (ADSP)', date: '2025.06' },
];

const awards = [
  { name: '천안시 스마트시티를 위한 AI 아이디어 공모전', detail: '우수상' },
];

const projects = [
  {
    name: 'VERITAS',
    type: '로컬 기반 AI 리서치·문서작성 어시스턴트',
    badge: '캡스톤디자인',
    period: '2026.03 - 2026.06',
    team: '3인 프로젝트',
    stack: ['Python', 'FastAPI', 'PySide6', 'llama.cpp', 'ChromaDB', 'RAG'],
    summary:
      '내부 자료를 외부로 보내지 않고, 주제만 입력하면 조사·검증·문서 작성을 PC 안에서 처리하는 로컬 우선 AI 데스크톱 어시스턴트입니다.',
    highlights: [
      'AutoSurvey: 주제 그라운딩 → 쿼리 계획 → 웹 수집 → 요약 → 갭 분석 → 재계획 루프로 자동 리서치·보고서 생성',
      'RAG 채팅: ChromaDB 인덱싱 기반 근거 응답 — 근거가 없으면 답변을 거부하도록 설계',
      '검증 엔진: 임베딩 + IR(BM25) + LLM 교차검증으로 문서 간 수치 불일치·상충을 탐지하고 신뢰도 점수화',
      '로컬 우선: llama.cpp / GGUF 추론과 Granite 임베딩으로 내부 자료 외부 전송 0 (OpenAI는 리서치 단계에서만 선택적 사용)',
    ],
    troubleshooting:
      '로컬에서 두 개의 llama-server(추론·임베딩)와 FastAPI 백엔드, PySide6 GUI를 동시에 구동하면서 Windows Job Object로 자식 프로세스를 일괄 정리해, 좀비 프로세스 없이 안정적으로 실행되도록 구성했습니다.',
    image: '/image/veritas.png',
    links: [
      { label: 'GitHub', url: 'https://github.com/2026-1-CAU-Capstone-Design-Team2/veritas' },
      { label: 'Landing', url: 'https://veritas-web-nu.vercel.app/' },
    ],
  },
  {
    name: 'AcaManager',
    type: '종합 학원 관리 플랫폼',
    period: '2025.12 - 현재',
    team: '개인 프로젝트',
    stack: ['Spring Boot', 'React', 'Render', 'Vercel', 'Supabase'],
    summary: '학원 운영에 필요한 학습·관리·커뮤니케이션 기능을 하나로 통합한 플랫폼입니다.',
    highlights: [
      'Spring Boot + React 기반 핵심 기능 단독 개발',
      '배포 환경 구성 및 학생별 리포트·필터링 구현',
      '서울 소재 학원 2개 팀에서 실제 사용 예정',
    ],
    troubleshooting:
      '조회 성능 저하를 배포 설정 개선, N+1 해결, 페이지네이션, DB 배치 처리로 단계적으로 개선했습니다.',
    image: '/image/acamanager.png',
    links: [{ label: 'Domain', url: 'https://acamanager.site' }],
  },
  {
    name: 'ORDER101',
    type: 'B2B 주문 관리 시스템',
    period: '2025.10 - 2025.12',
    team: '5인 프로젝트 · 팀장',
    stack: ['Spring Boot', 'Vue.js', 'Python', 'AI Modeling', 'AWS'],
    summary: 'AI 기반 발주·재고·주문 자동화로 운영 효율을 높인 B2B 시스템입니다.',
    highlights: [
      'EDA + 앙상블 수요예측 모델 구축으로 오차율 50% 감소',
      'OpenAI API 기반 사내 전용 챗봇 및 스마트 발주·배송 도메인 구현',
    ],
    troubleshooting:
      '수요예측 보고서 지연 이슈를 Spring Cache + Redis로 해결하고, JPA Lazy Proxy 직렬화 문제를 서비스 레이어 초기화 방식으로 안정화했습니다.',
    image: '/image/order101.png',
    links: [{ label: 'GitHub', url: 'https://github.com/beyond-sw-camp/be18-fin-SYNERGY-ORDER101' }],
  },
  {
    name: 'SpecGuard',
    type: '이력서 정합 플랫폼 (B2B SaaS)',
    period: '2025.10 - 2025.12',
    team: '6인 프로젝트',
    stack: ['FastAPI', 'Playwright', 'NLP', 'Spring Boot', 'Vue.js'],
    summary: '이력서·포트폴리오의 정합성을 자동 분석해 채용을 지원하는 플랫폼입니다.',
    highlights: [
      'Python 서버 총괄: Velog 크롤링 + FastAPI 연동',
      'NLP 요약·키워드 추출 및 정합성 점수 계산 파이프라인 구현',
    ],
    troubleshooting:
      'Playwright + Windows 이벤트 루프 충돌을 Proactor 루프 강제 및 실행 진입점 분리(run.py)로 안정화했습니다.',
    image: '/image/specguard.png',
    links: [
      { label: 'BE GitHub', url: 'https://github.com/beyond-sw-camp/be18-2nd-SixSpecs-SpecGuard' },
      { label: 'FE GitHub', url: 'https://github.com/beyond-sw-camp/be18-3rd-SixSpecs-SpecGuard' },
    ],
  },
  {
    name: '삼성회계법인',
    type: '안산지점 홈페이지 제작',
    period: '2026.02 - 현재',
    team: '진행 중',
    stack: ['React', 'JavaScript', 'CSS'],
    summary: '삼성회계법인 안산지점 홈페이지 제작 및 마케팅 전략 수립을 담당했습니다.',
    highlights: ['브랜드 톤에 맞춘 레이아웃 설계', '콘텐츠 구조 정리 및 반응형 화면 제작'],
    troubleshooting:
      '진행 중인 프로젝트로, 요구사항에 맞춰 UI와 구조를 지속적으로 개선하고 있습니다.',
    image: '/image/ssacc.png',
    links: [{ label: 'Domain', url: 'https://ssacc-website.vercel.app/' }],
  },
  {
    name: '데이터 안심구역',
    type: '삼성카드 매출 기반 마케팅 전략 수립',
    period: '2025.01 - 2025.02',
    team: '4인 프로젝트',
    stack: ['Python', 'EDA', 'Data Analysis'],
    summary: '데이터 안심구역 환경에서 삼성카드 매출 데이터를 분석해 마케팅 전략을 수립했습니다.',
    highlights: ['실매출 데이터 기반 고객 세분화 및 인사이트 도출', '분석 결과를 바탕으로 타겟별 마케팅 전략 제안'],
    troubleshooting:
      '제한된 분석 환경에서 데이터 전처리와 변수 설계를 표준화해 팀 협업 효율을 높였습니다.',
    image: '/image/datasafety.png',
    links: [{ label: 'GitHub', url: 'https://github.com/sangwon5579/Data_Safety_Zone' }],
  },
];

const navItems = [
  { id: 'about', label: 'About' },
  { id: 'education', label: 'Education' },
  { id: 'projects', label: 'Projects' },
  { id: 'skills', label: 'Skills' },
  { id: 'credentials', label: 'Credentials' },
  { id: 'contact', label: 'Contact' },
];

const stats = [
  { value: projects.length, label: 'Projects' },
  { value: certifications.length, label: 'Certificates' },
  { value: awards.length, label: 'Awards' },
];

function App() {
  const [openProject, setOpenProject] = useState(null);
  const [activeSection, setActiveSection] = useState('about');

  // Scroll-spy: highlight the nav item for the section in view.
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
    );

    navItems.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  // Reveal sections as they scroll into view.
  // Robust by design: content is never left hidden if IntersectionObserver
  // can't run (reduced motion, unsupported, or a non-visible tab).
  useEffect(() => {
    const els = Array.from(document.querySelectorAll('.reveal'));
    const reveal = (el) => el.classList.add('is-visible');
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced || typeof IntersectionObserver === 'undefined') {
      els.forEach(reveal);
      return undefined;
    }

    // Show anything already in the first viewport immediately (no IO dependency).
    const vh = window.innerHeight || 800;
    els.forEach((el) => {
      if (el.getBoundingClientRect().top < vh * 0.9) reveal(el);
    });

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    els.forEach((el) => {
      if (!el.classList.contains('is-visible')) io.observe(el);
    });

    // Safety net: if IO never delivers (e.g. backgrounded tab), reveal all.
    const fallback = window.setTimeout(() => els.forEach(reveal), 2500);

    return () => {
      io.disconnect();
      window.clearTimeout(fallback);
    };
  }, []);

  // Modal: lock body scroll + close on Escape.
  useEffect(() => {
    if (!openProject) return undefined;

    const onKey = (event) => {
      if (event.key === 'Escape') setOpenProject(null);
    };

    document.addEventListener('keydown', onKey);
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previous;
    };
  }, [openProject]);

  return (
    <div className="portfolio">
      <div className="bg-orb bg-orb-a" aria-hidden="true" />
      <div className="bg-orb bg-orb-b" aria-hidden="true" />
      <div className="floating-lines-layer" aria-hidden="true">
        <FloatingLines
          enabledWaves={['top', 'middle', 'bottom']}
          lineCount={5}
          lineDistance={5}
          bendRadius={5}
          bendStrength={-0.5}
          interactive
          parallax
          linesGradient={['#1C4FA5', '#2E73DE', '#77B4FF']}
          mixBlendMode="normal"
        />
      </div>

      <header className="topbar">
        <a className="brand" href="#top">
          <span className="brand-mark" aria-hidden="true" />
          {profile.nameEn}
        </a>
        <nav className="topbar-nav">
          {navItems.map(({ id, label }) => (
            <a key={id} href={`#${id}`} className={activeSection === id ? 'is-active' : ''}>
              {label}
            </a>
          ))}
        </nav>
        <a className="topbar-cta" href="#contact">
          Contact
        </a>
      </header>

      <main id="top">
        <section className="hero reveal" id="hero">
          <div className="hero-text">
            <p className="hero-tag">Portfolio</p>
            <SplitText
              tag="h1"
              className="hero-name"
              text={profile.name}
              splitType="chars"
              delay={70}
              duration={0.9}
              threshold={0.25}
              textAlign="left"
            />
            <p className="hero-role">{profile.role}</p>
            <p className="hero-desc">{profile.intro}</p>

            <div className="hero-keywords">
              {focusKeywords.map((word) => (
                <span key={word} className="keyword">
                  {word}
                </span>
              ))}
            </div>

            <div className="hero-actions">
              <a className="btn btn-primary" href="#projects">
                프로젝트 보기
              </a>
              <a className="btn btn-ghost" href={profile.github} target="_blank" rel="noreferrer">
                GitHub
              </a>
            </div>
          </div>

          <aside className="hero-panel" aria-label="요약">
            <p className="hero-panel-quote">“{profile.tagline}”</p>
            <ul className="hero-facts">
              <li>
                <span>Role</span>
                <strong>{profile.role}</strong>
              </li>
              <li>
                <span>Education</span>
                <strong>중앙대 소프트웨어학부</strong>
              </li>
              <li>
                <span>Focus</span>
                <strong>Backend · Cloud · Data</strong>
              </li>
            </ul>
            <div className="hero-stats">
              {stats.map((stat) => (
                <div key={stat.label} className="hero-stat">
                  <strong>{stat.value}</strong>
                  <span>{stat.label}</span>
                </div>
              ))}
            </div>
          </aside>
        </section>

        <section id="about" className="section reveal" data-index="01">
          <div className="section-head">
            <SplitText tag="h2" text="About" splitType="chars" delay={32} duration={0.7} threshold={0.4} textAlign="left" />
            <p>기획부터 개발·운영까지 연결해 제품 완성도를 높이는 개발자</p>
          </div>

          <div className="about-grid">
            <article className="about-photo-card">
              <div className="about-photo-frame">
                <img src={profile.photo} alt="조상원 프로필 사진" className="about-photo" />
              </div>
              <h3>{profile.name}</h3>
              <p className="about-photo-en">{profile.nameEn}</p>
            </article>

            <article className="about-info-card">
              <ul className="info-list">
                <li>
                  <span>Birth</span>
                  <strong>{profile.birth}</strong>
                </li>
                <li>
                  <span>Phone</span>
                  <strong>{profile.phone}</strong>
                </li>
                <li>
                  <span>Email</span>
                  <a href={`mailto:${profile.email}`}>{profile.email}</a>
                </li>
                <li>
                  <span>GitHub</span>
                  <a href={profile.github} target="_blank" rel="noreferrer">
                    github.com/sangwon5579
                  </a>
                </li>
                <li>
                  <span>Blog</span>
                  <a href={profile.blog} target="_blank" rel="noreferrer">
                    velog.io/@sangwon5579
                  </a>
                </li>
              </ul>
            </article>
          </div>
        </section>

        <section id="education" className="section reveal" data-index="02">
          <div className="section-head">
            <SplitText tag="h2" text="Education" splitType="chars" delay={30} duration={0.7} threshold={0.4} textAlign="left" />
            <p>학력 및 대내외 활동</p>
          </div>

          <div className="edu-grid">
            <article className="edu-degree">
              <p className="edu-period">{education.period}</p>
              <h3>{education.school}</h3>
              <p className="edu-major">{education.degree}</p>
              <div className="edu-capstone">
                <strong>{education.capstone.title}</strong>
                <span>{education.capstone.desc}</span>
              </div>
            </article>

            <article className="activity-card">
              <h3 className="activity-title">Activities</h3>
              <ul className="timeline">
                {activities.map((activity) => (
                  <li key={activity.title}>
                    <span className="timeline-dot" aria-hidden="true" />
                    <p className="timeline-period">{activity.period}</p>
                    {activity.url ? (
                      <a className="timeline-name timeline-link" href={activity.url} target="_blank" rel="noreferrer">
                        {activity.title}
                      </a>
                    ) : (
                      <p className="timeline-name">{activity.title}</p>
                    )}
                  </li>
                ))}
              </ul>
            </article>
          </div>
        </section>

        <section id="projects" className="section reveal" data-index="03">
          <div className="section-head">
            <SplitText tag="h2" text="Projects" splitType="chars" delay={30} duration={0.7} threshold={0.4} textAlign="left" />
            <p>문제를 정의하고 제품으로 완성한 주요 프로젝트</p>
          </div>

          <div className="project-grid">
            {projects.map((project) => (
              <article
                key={project.name}
                className={`project-card ${openProject?.name === project.name ? 'is-open' : ''}`}
                role="button"
                tabIndex={0}
                aria-label={`${project.name} 프로젝트 상세 보기`}
                onClick={() => setOpenProject(project)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    setOpenProject(project);
                  }
                }}
              >
                <div className="project-thumb">
                  <img src={project.image} alt={`${project.name} 메인 화면`} loading="lazy" />
                  {project.badge && <span className="project-badge">{project.badge}</span>}
                </div>

                <div className="project-body">
                  <div className="project-card-head">
                    <h3>{project.name}</h3>
                    <span className="project-team">{project.team}</span>
                  </div>
                  <p className="project-type">{project.type}</p>
                  <p className="project-period">{project.period}</p>
                  <p className="project-summary">{project.summary}</p>

                  <div className="project-stack">
                    {project.stack.map((tech) => (
                      <span key={tech} className="tag">
                        {tech}
                      </span>
                    ))}
                  </div>

                  <span className="project-more">자세히 보기 →</span>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="skills" className="section reveal" data-index="04">
          <div className="section-head">
            <SplitText tag="h2" text="Skills" splitType="chars" delay={30} duration={0.7} threshold={0.4} textAlign="left" />
            <p>주로 사용하는 기술 스택</p>
          </div>

          <div className="skills-grid">
            {skillGroups.map((group) => (
              <article className="skill-group" key={group.title}>
                <h3>{group.title}</h3>
                <div className="tag-row">
                  {group.items.map((item) => (
                    <span key={item} className="tag">
                      {item}
                    </span>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="credentials" className="section reveal" data-index="05">
          <div className="section-head">
            <SplitText tag="h2" text="Credentials" splitType="chars" delay={30} duration={0.7} threshold={0.4} textAlign="left" />
            <p>자격증 및 수상 내역</p>
          </div>

          <div className="credentials-grid">
            <article className="credential-col">
              <h3 className="credential-label">Certificates</h3>
              <ul className="credential-list">
                {certifications.map((item) => (
                  <li key={item.name}>
                    <span className="credential-name">{item.name}</span>
                    <span className="credential-date">{item.date}</span>
                  </li>
                ))}
              </ul>
            </article>

            <article className="credential-col">
              <h3 className="credential-label">Awards</h3>
              <ul className="credential-list">
                {awards.map((item) => (
                  <li key={item.name}>
                    <span className="credential-name">{item.name}</span>
                    <span className="credential-tag">{item.detail}</span>
                  </li>
                ))}
              </ul>
            </article>
          </div>
        </section>

        <section id="contact" className="section contact reveal" data-index="06">
          <div className="contact-inner">
            <SplitText tag="h2" text="Contact" splitType="chars" delay={30} duration={0.7} threshold={0} rootMargin="0px" textAlign="left" />
            <p className="contact-lead">
              새로운 기회와 협업을 기다리고 있습니다. 편하게 연락 주세요.
            </p>
            <div className="contact-links">
              <a href={`mailto:${profile.email}`} className="contact-link primary">
                {profile.email}
              </a>
              <a href={profile.github} target="_blank" rel="noreferrer" className="contact-link">
                GitHub
              </a>
              <a href={profile.blog} target="_blank" rel="noreferrer" className="contact-link">
                Blog
              </a>
              <a href={`tel:${profile.phone.replace(/-/g, '')}`} className="contact-link">
                {profile.phone}
              </a>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <span>© 2026 {profile.name} ({profile.nameEn})</span>
        <span className="footer-meta">Designed &amp; Built by {profile.nameEn}</span>
      </footer>

      {openProject && (
        <div className="modal-backdrop" onClick={() => setOpenProject(null)}>
          <div
            className="modal"
            role="dialog"
            aria-modal="true"
            aria-label={`${openProject.name} 프로젝트`}
            onClick={(event) => event.stopPropagation()}
          >
            <button type="button" className="modal-close" aria-label="닫기" onClick={() => setOpenProject(null)}>
              ✕
            </button>

            <img src={openProject.image} alt={`${openProject.name} 메인 화면`} className="modal-image" />

            <div className="modal-body">
              <div className="modal-head">
                <h3>{openProject.name}</h3>
                {openProject.badge && <span className="project-badge inline">{openProject.badge}</span>}
              </div>
              <p className="modal-type">{openProject.type}</p>
              <p className="modal-meta">
                {openProject.period} · {openProject.team}
              </p>

              <div className="project-stack">
                {openProject.stack.map((tech) => (
                  <span key={tech} className="tag">
                    {tech}
                  </span>
                ))}
              </div>

              <p className="modal-summary">{openProject.summary}</p>

              <h4 className="modal-subhead">주요 작업</h4>
              <ul className="modal-list">
                {openProject.highlights.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              <p className="modal-trouble">
                <strong>Troubleshooting</strong>
                {openProject.troubleshooting}
              </p>

              {openProject.links && openProject.links.length > 0 && (
                <div className="modal-links">
                  {openProject.links.map((item) => (
                    <a
                      key={`${openProject.name}-${item.label}`}
                      href={item.url}
                      target="_blank"
                      rel="noreferrer"
                      className="modal-link"
                    >
                      {item.label} ↗
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
